// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  users: any = 0;
  roles = 0;
  policies = 0;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.getDashboardData().subscribe(dashboard => {
      this.users = dashboard.Users || 0;
      this.roles = dashboard.Roles || 0;
      this.policies = dashboard.Policies || 0;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/dashboard/dashboard.component.ts